module.exports = __webpack_public_path__ + "static/media/lonerism.8e64f5d7.jpg";